import React, { useState } from "react";
import { Box, IconButton, InputAdornment, TextField, Tooltip, Typography } from "@mui/material";
import VisibilityIcon from "@mui/icons-material/Visibility";
import VisibilityOffIcon from "@mui/icons-material/VisibilityOff";
import { COLORS } from "./constants";
import { commonInputProps, inputSx } from "./styles";
import { CopyAdornment } from "./CopyAdornment";

// `secret` hides the value until the user asks to see it. Stream keys and
// passphrases were shown in clear text on a page people screen-share and record;
// anyone who sees a key can stream to the channel. Copy still copies the real
// value without revealing it.
export function CopyableField({ label, value, fieldId, copiedField, onCopy, sx, secret = false }) {
  const [revealed, setRevealed] = useState(false);
  const hidden = secret && !revealed;

  return (
    <Box>
      {label && (
        <Typography component="span" sx={{ display: "block", mb: 0.75, color: COLORS.muted, fontSize: 12, fontWeight: 600 }}>
          {label}
        </Typography>
      )}
      <TextField
        {...commonInputProps}
        value={value}
        type={hidden ? "password" : "text"}
        sx={sx ? { ...inputSx, ...sx } : inputSx}
        inputProps={{ "aria-label": label || fieldId }}
        InputProps={{
          readOnly: true,
          endAdornment: (
            <>
              {secret && (
                <InputAdornment position="end" sx={{ mr: -0.5 }}>
                  <Tooltip title={hidden ? "Show" : "Hide"}>
                    <IconButton
                      size="small" onClick={() => setRevealed((v) => !v)}
                      aria-label={hidden ? `Show ${label || "value"}` : `Hide ${label || "value"}`}
                      aria-pressed={!hidden}
                    >
                      {hidden
                        ? <VisibilityIcon sx={{ color: COLORS.muted, fontSize: 17 }} />
                        : <VisibilityOffIcon sx={{ color: COLORS.muted, fontSize: 17 }} />}
                    </IconButton>
                  </Tooltip>
                </InputAdornment>
              )}
              <CopyAdornment value={value} fieldId={fieldId} copiedField={copiedField} onCopy={onCopy} />
            </>
          )
        }}
      />
    </Box>
  );
}
